import React, {useState} from 'react';

import WarningIcon from '../../../../../../../assets/svgComponents/WarningIcon';
import ToolTipComponent from '../../../../toolTipComponent';

import './copyingPropertyDisabledComponent.css';

const CopyingPropertyDisabledComponent = ({
  toolTipPosition = 'right',
  toolTipTxt = 'Changes to this field will not be applied to all the selected widgets/agents.',
}) => {
  const [showToolTip, setShowToolTip] = useState(false);

  const handleToolTip = () => {
    setShowToolTip(!showToolTip);
  };

  return (
    <div
      className="et-copying-property-disabled-component-container"
      onMouseEnter={handleToolTip}
      onMouseLeave={handleToolTip}
      onClick={handleToolTip}>
      <WarningIcon fillColor="#fd0061" width={13} height={13} />
      {showToolTip && toolTipTxt && (
        <ToolTipComponent
          toolTipPosition={toolTipPosition}
          toolTipTxt={toolTipTxt}
        />
      )}
    </div>
  );
};

export default CopyingPropertyDisabledComponent;
